// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { api } from 'jsw';

export const listNotifications = id => api.get('/admin/notifications/list', { 'filter[older]': id });

export const updateNotifications = (ids, change) => api.post('/admin/notifications/update', { ids, ...change });

export const deleteNotifications = ids => api.post('/admin/notifications/delete', { ids });
